import React from 'react';
import _ from 'lodash';
import { useParameterizedQuery } from 'react-fetching-library';
import { Modal, Card, CardContent, CardHeader, Button, IconButton, Stack, Typography } from '@mui/material';
import { getDocuments } from '../../../services/request';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CloseIcon from '@mui/icons-material/Close';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function DownloadDocumentsModal({ order, open, handleClose }) {
  const { query } = useParameterizedQuery(getDocuments);

  const downloadFile = async (template_name, fileName, annex_id = 0) => {
    const { payload, error, loading } = await query(order.id, template_name, annex_id);
    if (!error && !loading) {
      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `${fileName}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error(`Nie udało się pobrać ${fileName}.pdf`);
    }
  };

  const handleDownload = async () => {
    await downloadFile('agreement', 'umowa');
    await downloadFile('qualification_card', 'karta kwalifikacyjna');
    await downloadFile('terms_of_participation', 'warunki uczestnictwa');
  };


  return (
    <Modal open={open} onClose={handleClose}>
      <Card sx={{ ...style, width: '400px' }}>
        <CardHeader
          title="Zmiana statusu"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent>
          <Stack alignItems="center" spacing={2}>
            <Typography variant="body2">
              Dokumenty powinny zostać wysłane pocztą tradycyjną.
            </Typography>
            <Button variant="contained" onClick={handleDownload} startIcon={<FileDownloadIcon />}>Pobierz dokumenty</Button>
          </Stack>
        </CardContent>
      </Card>
    </Modal>);
};
